const MESSAGE_BANK = {
  difficulty_shift: [
    "Finley picked this because you're ready for a new challenge!",
    "You're doing so well, Finley found something a little harder!",
    'Finley is giving you some practice to build your confidence.'
  ],
  leitner_review: [
    'This word is coming back because practice makes perfect!',
    "Finley remembers you're learning this word. Let's practice!",
    "You've seen this one before. Finley wants to make sure it sticks!"
  ],
  skill_milestone: [
    "You're getting really good at this!",
    "Finley noticed you're getting faster!",
    "Almost there! You're so close to mastering this."
  ],
  session_start: [
    "Finley built today's adventure just for you!",
    "Today's session is personalized based on your progress!"
  ],
  periodic: [
    "Finley is tuning this adventure to your progress!",
    'Great focus! Finley is picking what helps most next.',
    'Your adventure keeps adjusting as you play!'
  ]
};

const PRIORITY = ['difficulty_shift', 'leitner_review', 'skill_milestone', 'periodic'];
const MIN_GAP_MS = 45000;
const RECENT_CAP = 6;

const sessionState = {
  lastShownAt: 0,
  lastMessage: null,
  recentMessages: [],
  shownActivityKeys: new Set(),
  sessionStartShown: false
};

function pickMessage(category) {
  const pool = MESSAGE_BANK[category] || [];
  if (!pool.length) return null;
  const filtered = pool.filter((m) => !sessionState.recentMessages.includes(m) && m !== sessionState.lastMessage);
  const candidates = filtered.length ? filtered : pool.filter((m) => m !== sessionState.lastMessage);
  const source = candidates.length ? candidates : pool;
  const message = source[Math.floor(Math.random() * source.length)];
  sessionState.lastMessage = message;
  sessionState.recentMessages.push(message);
  if (sessionState.recentMessages.length > RECENT_CAP) sessionState.recentMessages.shift();
  return message;
}

export function resetInsightSession() {
  sessionState.lastShownAt = 0;
  sessionState.lastMessage = null;
  sessionState.recentMessages = [];
  sessionState.shownActivityKeys.clear();
  sessionState.sessionStartShown = false;
}

export function getInsightMessage(context = {}) {
  const now = Date.now();
  const activityKey = context.activityKey || null;
  const force = !!context.force;

  if (activityKey && sessionState.shownActivityKeys.has(activityKey)) return null;
  if (!force && now - sessionState.lastShownAt < MIN_GAP_MS) return null;

  let category = null;

  if (context.sessionStart && !sessionState.sessionStartShown) {
    category = 'session_start';
    sessionState.sessionStartShown = true;
  } else if (Array.isArray(context.triggers) && context.triggers.length) {
    category = PRIORITY.find((p) => context.triggers.includes(p)) || null;
  } else if (context.trigger) {
    category = context.trigger;
  }

  if (!category) return null;

  const message = pickMessage(category);
  if (!message) return null;

  if (activityKey) sessionState.shownActivityKeys.add(activityKey);
  sessionState.lastShownAt = now;
  return message;
}
